/**
 * A4 landscape dimensions at 96 DPI.
 * Shared between the Tiptap editor (via pageFormat.ts) and the public page.
 *
 * `contentAreaHeightPxForBrand` must match the editor’s available body area
 * (PageSectionView + PageHeader) so `useContentPages` splits like the editor.
 *
 * UBO: header 50px → contentAreaHeightPxForBrand('ubo').
 * UBX: header 110px (hoger agency-logo) → `contentAreaHeightPxForBrand('ubx')`.
 *
 * A page block is the sheet height minus a 5 mm bottom margin ≈ 774.8 px.
 */
const DPI = 96;
const CM_PER_INCH = 2.54;
const PX_PER_CM = DPI / CM_PER_INCH;

export const A4_WIDTH_CM = 29.7;
export const A4_HEIGHT_CM = 21;

export const A4_WIDTH_PX = A4_WIDTH_CM * PX_PER_CM;
export const A4_HEIGHT_PX = A4_HEIGHT_CM * PX_PER_CM;

export const PAGE_PADDING_PX = 50;
export const HEADER_HEIGHT_PX = 50;
/** Gelijk aan PageHeader `minHeight` bij brand `ubx` (agency-logo 110px). */
export const HEADER_HEIGHT_UBX_PX = 110;
export const HEADER_GAP_PX = 24;

const PAGE_BOTTOM_MARGIN_CM = 0.5;
const PAGE_BOTTOM_MARGIN_PX = PAGE_BOTTOM_MARGIN_CM * PX_PER_CM;

export const PAGE_MAX_HEIGHT_PX =
  A4_HEIGHT_PX - PAGE_BOTTOM_MARGIN_PX;

/**
 * Beschikbare hoogte voor body-HTML onder header + marge.
 * UBX heeft een hogere header → kleinere contentruimte dan UBO.
 */
export function contentAreaHeightPxForBrand(brand: 'ubo' | 'ubx'): number {
  const headerH = brand === 'ubx' ? HEADER_HEIGHT_UBX_PX : HEADER_HEIGHT_PX;
  return PAGE_MAX_HEIGHT_PX - PAGE_PADDING_PX - headerH - HEADER_GAP_PX;
}

/** Alias voor UBO (backward compat). */
export const CONTENT_HEIGHT_PX = contentAreaHeightPxForBrand('ubo');
